import { Component } from '@angular/core';
import { MatTab,MatTabGroup } from '@angular/material/tabs';

@Component({
    selector: 'app-sidebar-notice',
    templateUrl: './sidebar-notice.component.html',
    styleUrls: ['./sidebar-notice.component.scss'],
    standalone: true,
    imports: [MatTabGroup, MatTab]
})
export class SidebarNoticeComponent {}
